<template>
  <div></div>
</template>

<script>
  export default {
    components: {},
    data() {
      return {}
    },
    computed: {},
    watch: {},
    methods: {},
    created() {},
    mounted() {},
  }
</script>
<style lang='less' scoped>
</style>
